const addressZipCodeRegExp = /^\d{5}(-\d{4})?$/
const cardAmexRegExp = /^37|^34/
const nameRegExp = /^([a-zA-Z\s-]{1,22})$/
const ssnRegExp = /^(?!000|666)[0-8][0-9]{2}(?!00)[0-9]{2}(?!0000)[0-9]{4}$/

export { addressZipCodeRegExp, cardAmexRegExp, nameRegExp, ssnRegExp }
